<template>
    <main>
     <div class="alert alert-primary shadow-none border-left-lg border-left-primary rounded-lg p-2 m-1 mb-2">
            <i class="fa fa-info-circle fa-fw text-primary animate__animated animate__heartBeat animate__infinite"></i>
            <span>Víctima del conflicto armado.</span>
        </div>
    </main>
</template>
<script>
import "animate.css"
export default {
  name: 'VictimArmedConflict',
}
</script>
